import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_ASPECTOS, API_ATUALIZAR_ASPECTOS } from 'store/modules/api/aspectos.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ASPECTOS.success:
      return payload
    case API_ATUALIZAR_ASPECTOS.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_ASPECTOS)

const isUpdate = loadingReducer(false, API_ATUALIZAR_ASPECTOS)

export default combineReducers({
  lista,
  isCarregandoLista,
  isUpdate,
})
